import * as propUtil from './prop-util'
import render from './render'

export default function () {
  // Really only call this if a user event really forces us to repaint!
  render(propUtil.merge())
}
